import React from "react";

const Community = () => {
  const handleTelegramJoin = () => {
    window.open("https://t.me/+PgbVUDnoNWAxNjEx", "_blank", "noopener,noreferrer");
  };

  const handleViewRankings = () => {
    window.location.href = "/leaderboard";
  };

  const handleGetNotified = () => {
    const email = prompt("Enter your email to get notified about updates:");
    if (email) {
      console.log("User subscribed with email:", email);
      alert("Thank you! We'll notify you about important updates.");
    }
  };

  return (
    <section id="community" className="py-20 bg-gradient-to-br from-gray-900 to-black relative overflow-hidden">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-black bg-gradient-to-r from-white to-gray-300 bg-clip-text text-transparent mb-4">
            Join the Movement
          </h2>
          <p className="text-xl text-gray-300 max-w-2xl mx-auto">
            Builders, stakers, dreamers — we're aligning code with climate. 
            Be part of the green chain revolution.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div className="backdrop-blur-lg bg-white/10 border border-white/20 p-8 rounded-3xl text-center group hover:transform hover:scale-105 transition-all duration-500 hover:shadow-2xl hover:shadow-white/10">
            <div className="w-20 h-20 bg-gradient-to-r from-white to-gray-300 rounded-2xl mx-auto flex items-center justify-center text-gray-900 text-2xl mb-6 group-hover:rotate-12 transition-transform duration-500">
              👥
            </div>
            <h3 className="text-2xl font-black text-white mb-4">Community</h3>
            <p className="text-gray-300 mb-6">
              Connect with like-minded individuals building sustainable Web3 solutions.
            </p>
            <button 
              onClick={handleTelegramJoin}
              className="w-full py-3 font-bold bg-gradient-to-r from-white to-gray-300 hover:from-gray-200 hover:to-gray-400 text-gray-900 rounded-xl transition-all duration-300 transform hover:-translate-y-1"
            >
              Join Telegram
            </button>
          </div>

          <div className="backdrop-blur-lg bg-white/10 border border-white/20 p-8 rounded-3xl text-center group hover:transform hover:scale-105 transition-all duration-500 hover:shadow-2xl hover:shadow-gray-300/10">
            <div className="w-20 h-20 bg-gradient-to-r from-white to-gray-300 rounded-2xl mx-auto flex items-center justify-center text-gray-900 text-2xl mb-6 group-hover:rotate-12 transition-transform duration-500">
              🏆
            </div>
            <h3 className="text-2xl font-black text-white mb-4">Leaderboard</h3>
            <p className="text-gray-300 mb-6">
              Early matters. Top contributors unlock future governance perks and rewards.
            </p>
            <button 
              onClick={handleViewRankings}
              className="w-full py-3 font-bold bg-transparent border-2 border-gray-300 hover:bg-gray-300 text-gray-300 hover:text-gray-900 rounded-xl transition-all duration-300 transform hover:-translate-y-1"
            >
              View Rankings
            </button>
          </div>

          <div className="backdrop-blur-lg bg-white/10 border border-white/20 p-8 rounded-3xl text-center group hover:transform hover:scale-105 transition-all duration-500 hover:shadow-2xl hover:shadow-white/10">
            <div className="w-20 h-20 bg-gradient-to-r from-white to-gray-300 rounded-2xl mx-auto flex items-center justify-center text-gray-900 text-2xl mb-6 group-hover:rotate-12 transition-transform duration-500">
              📱
            </div>
            <h3 className="text-2xl font-black text-white mb-4">Stay Updated</h3>
            <p className="text-gray-300 mb-6">
              Get real-time notifications about airdrops, staking missions, and network updates.
            </p>
            <button 
              onClick={handleGetNotified}
              className="w-full py-3 font-bold bg-gradient-to-r from-white to-gray-300 hover:from-gray-200 hover:to-gray-400 text-gray-900 rounded-xl transition-all duration-300 transform hover:-translate-y-1"
            >
              Get Notified
            </button>
          </div>
        </div>

        <div className="text-center mt-16">
          <p className="text-gray-400 mb-6">As seen in the community:</p>
          <div className="backdrop-blur-lg bg-white/10 border border-white/20 p-6 rounded-3xl max-w-2xl mx-auto">
            <p className="text-lg italic text-gray-300 mb-4">
              "Just claimed my $X1 airdrop ⚪ A green chain that actually runs cleaner than my coffee maker. #X1EcoChain #GreenBlockchain #Web3"
            </p>
            <div className="flex items-center justify-center space-x-4">
              <div className="w-10 h-10 bg-gradient-to-r from-white to-gray-300 rounded-full"></div>
              <div>
                <div className="font-semibold text-white">@EcoWarrior</div>
                <div className="text-gray-400 text-sm">Community Member</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Community;